import { useContext } from "react";
import { ThemeContext } from "styled-components";

export function useIsMobileDevice(): boolean {
  const themeContext = useContext(ThemeContext);
  if (typeof window === "undefined") {
    return false;
  }

  return (
    window.screen.width <=
    (parseInt(themeContext?.breakpoints?.tablet, 10) || 414)
  );
}
